import { useTranslation } from 'react-i18next';

const InternalTransferLeverageBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full shadow-smooth h-full flex flex-col items-start gap-2 bg-bg rounded-2xl px-[2.4rem] py-[1.6rem]">
      <div className="h-[24px] flex flex-row items-center gap-[10px]">
        <img
          src="/assets/warning-status-icon.svg"
          alt="Warning"
          className={'h-[20px] w-[20px]'}
        />
        <div className="headline5">
          {t('internalTransferModal.leverageTransferWarningTitle')}
        </div>
      </div>
      <div className="font-normal leading-[2rem] text-[1.4rem] break-word">
        {t('internalTransferModal.leverageTransferWarningSubtitle')}
      </div>
    </div>
  );
};

export default InternalTransferLeverageBanner;
